<template>
    <div class="scroll_flex_container">
        <!-- 分類按鈕 -->
        <div class="row_center_start categories" ref="menu">
            <div v-for="(category, index) in this.categories" :key="index" @click="scrollToCategory(index)"
                :class="{ active: index === currentCategory }">
                {{ category.categoryName }}
            </div>
        </div>

        <!-- 商品區域 -->
        <div class="column_center_start products" ref="products" @scroll="handleScroll">
            <div v-for="(category, categoryIndex) in displayProductsInCategory" :key="categoryIndex"
                class="column_center_start" style="width: 100%">
                <div v-for="(product, productIndex) in category.products" :key="productIndex" class="product">
                    <Product :product="product" @click="openProductDetail(product)"
                        :cartQuantity="selectedProductQuantity(product)"
                        :disabled="isProductSoldOut(product)">
                    </Product>
                </div>
            </div>
        </div>
        <SubSummary v-if="!showProductDetail && !showComboDetail" @toOrderConfirm="toOrderConfirm"></SubSummary>
        <div>
            <ProductDetail v-if="showProductDetail" @close="closeProductDetail" :product="selectedProduct">
            </ProductDetail>
            <comboDetail v-if="showComboDetail" @close="closeComboDetail" :product="selectedProduct">
            </comboDetail>
        </div>
    </div>
</template>
<script>
import product from "@/components/store/product.vue";
import productDetail from "@/components/store/productDetail.vue";
import comboDetail from "@/components/store/comboDetail.vue";
import subSummary from "@/components/store/subSummary.vue";
import commonUtilities from "@/utils/common.utils";
import { mapGetters } from "vuex";
export default {
    components: {
        Product: product,
        ProductDetail: productDetail,
        SubSummary: subSummary,
        comboDetail
    },
    data() {
        return {
            currentCategory: 0,
            enableScroll: true,
            showProductDetail: false,
            selectedProduct: {},
            showComboDetail: false
        };
    },
    computed: {
        cart() {
            return this.$store.state.cart.cart
        },
        getCurrentStore() {
            return this.$store.state.basic.currentStore;
        },
        getUrlParameters() {
            return this.$route.params
        },
        ...mapGetters("spreadsheet", {
            categories: "categories",
            productsInCategory: "productsInCategory",
            products: 'products',
            combos: 'combos'
        }),
        useDbData() {
            return this.$store.state.spreadsheet.useDbData
        },
        ...mapGetters('userData', {
            isLogin: 'isLogin',
            isStoreMember: 'isStoreMember'
        }),
        ...mapGetters('cart', {
            areaId: 'tableAreaId',
            tableIndex: 'tableIndex'
        }),
        displayProductsInCategory() {
            return this.productsInCategory.map(group => {
                return {
                    ...group,
                    products: group.products.filter(product => {
                        if (!product) return false
                        return product.availableInStore
                    })
                }
            })
        }
    },
    async created() {
        if (!this.isLogin || !this.isStoreMember) {
            console.log('未登入或非店家會員 跳轉至登入頁')
            const { method, areaId, tableIndex } = this.getUrlParameters
            if (this.$route.query.orderSource === 'tableOrder' && method === 'dineIn' && areaId && tableIndex !== undefined && tableIndex !== '') {
                this.$router.replace({
                    name: 'tableOrder',
                    params: {
                        store: this.getCurrentStore,
                        areaId,
                        tableIndex
                    }
                })
            } else {
                this.$router.replace({
                    path: `/${this.getCurrentStore}/store`
                })
            }
            return
        }
        this.restoreTableDataFromRoute()
        await this.getSpreadSheetData()
    },
    methods: {
        restoreTableDataFromRoute() {
            const { method, areaId, tableIndex } = this.getUrlParameters
            if (method !== 'dineIn') return
            if (!areaId || tableIndex === undefined || tableIndex === '') return

            const currentAreaId = this.$store.getters['cart/tableAreaId']
            const currentTableIndex = this.$store.getters['cart/tableIndex']
            const currentTableName = this.$store.getters['cart/tableName']
            if (currentAreaId === areaId && String(currentTableIndex) === String(tableIndex) && currentTableName) return

            const tableName = this.$store.getters['spreadsheet/tableName'](areaId, tableIndex)
            this.$store.commit('cart/setTableData', {
                tableName,
                areaId,
                tableIndex
            })
            this.$store.commit("cart/setPayment", {
                ...this.$store.state.cart.payment,
                consumptionPattern: 0
            })
        },
        async getSpreadSheetData() {
            let timeoutId = null;
            const timeoutPromise = new Promise((_, reject) => {
                timeoutId = setTimeout(() => {
                    reject(new Error('菜單讀取逾時，請稍後再試'));
                }, 30000);
            });

            const loadMenuTask = async () => {
                if (this.getUrlParameters.method === 'dineIn') {
                    await this.$store.dispatch('spreadsheet/loadDineInTables');
                    this.restoreTableDataFromRoute();
                }
                await this.$store.dispatch('spreadsheet/loadMenuData');
                console.log('商品', this.products);
                console.log('套餐', this.combos);
                console.log('分類', this.productsInCategory);
                await this.getProductImages();
                await this.getProductDescription();
            };

            try {
                commonUtilities.createLoading("資料讀取中", "請稍後");
                await Promise.race([
                    loadMenuTask(),
                    timeoutPromise
                ]);
                commonUtilities.closeLoading();
            } catch (e) {
                console.error('Failed to get products:', e);
                commonUtilities.closeLoading();
                await commonUtilities.delay(300);
                commonUtilities.createToast('error', e.message || '菜單讀取失敗');
                this.$router.go(-1);
            } finally {
                clearTimeout(timeoutId);
            }
        },
        async getProductImages() {
            await this.$store.dispatch('product/getProductImages')
        },
         async getProductDescription() {
            await this.$store.dispatch('product/fetchProductDescriptions')
        },
        toOrderConfirm() {
            const process = 'orderConfirm'
            const { method } = this.getUrlParameters
            this.$router.push({
                path: `/${this.getCurrentStore}/${process}/${method}/${this.areaId}/${this.tableIndex}`,
                query: this.$route.query
            })
        },
        // 回傳有選擇商品的數量
        selectedProductQuantity(product) {
            // 購物車中可能會有重複的商品 使用 product.id 判斷相同商品 並加總 quantity
            let quantity = 0
            if (!product) return quantity
            if (!this.cart || !this.cart.length) return quantity
            for (const item of this.cart) {
                if (!item) {
                    continue
                }
                if (item.product.id === product.id) {
                    quantity += item.quantity
                }
            }
            return quantity
        },
        openProductDetail(product) {
            if (this.isProductSoldOut(product)) {
                commonUtilities.createToast('warning', '商品已售完')
                return
            }
            console.log(product)
            this.selectedProduct = product
            // 根據product 中 comboSubSettings 來決定打開 productDetail 還是 comboDetail
            if (product.comboSubSettings !== undefined) {
                this.showComboDetail = true
            } else {
                this.showProductDetail = true
            }
        },
        isProductSoldOut(product) {
            return this.useDbData && Number(product?.stockMode) === 1 && product?.isStockSoldOut
        },
        closeProductDetail() {
            console.log('cart', this.cart)
            commonUtilities.closeLoading()
            this.showProductDetail = false
            this.selectedProduct = {}
        },
        closeComboDetail() {
            console.log('cart', this.cart)
            commonUtilities.closeLoading()
            this.showComboDetail = false
            this.selectedProduct = {}
        },
        scrollToCategory(index) {
            const menu = this.$refs.menu;
            this.currentCategory = index;

            const productsElement = this.$refs.products;
            const targetElement = productsElement.children[index];
            const targetOffset =
                targetElement.offsetTop - menu.clientHeight - menu.offsetTop;

            // this.enableScroll = false;
            // const that = this
            // const onScroll = () => {
            //     const currentScrollTop = productsElement.scrollTop;
            //     if (currentScrollTop === targetOffset) {
            //         that.enableScroll = true;

            //         productsElement.removeEventListener("scroll", onScroll);
            //     }
            // };

            // productsElement.addEventListener("scroll", onScroll);

            productsElement.scrollTo({
                top: targetOffset,
                behavior: "instant",
            });
        },
        handleScroll() {
            const menu = this.$refs.menu;
            // 如有需要調整需求 可以在滑動時不更新選中的分類
            // if (!this.enableScroll) {
            //   return;
            // }

            const productsElement = this.$refs.products;
            const scrollPosition =
                productsElement.scrollTop + menu.clientHeight + menu.offsetTop + 10;
            let productsInCategory = [...this.displayProductsInCategory];
            productsInCategory.forEach((category, index) => {
                const categoryElement = this.$refs.products.children[index];
                productsInCategory[index].offsetTop = categoryElement.offsetTop;
            });

            let currentCategoryIndex = 0;
            for (let i = 0; i < productsInCategory.length; i++) {
                // const category = this.products[i];
                const nextCategory = productsInCategory[i + 1];

                // 檢查是否為最後一個分類，或者滾動位置在兩個分類之間
                if (
                    !nextCategory ||
                    (
                        scrollPosition < nextCategory.offsetTop)
                ) {
                    currentCategoryIndex = i;
                    break;
                } else {
                    currentCategoryIndex = i + 1;
                }
            }

            const selectedCategory = this.$refs.menu.children[currentCategoryIndex];
            const menuScrollLeft = selectedCategory.offsetLeft - (menu.clientWidth - selectedCategory.clientWidth) / 2;
            this.$refs.menu.scrollTo({
                left: menuScrollLeft,
                behavior: "instant",
            });

            // 更新選中的分類
            this.currentCategory = currentCategoryIndex;
        },
    },
};
</script>
<style lang="scss"></style>
